import { Component, HostBinding, OnInit } from '@angular/core';
import { ListProjectOptions, ProjectService } from '../project.service';
import { Project, ProjectListFilter } from '../../models/project';
import { Paginator } from '../../models/paginator';
import { CreateProjectModal } from '../create-projekt-modal/create-project-modal';
import { AlertService } from '../../core/alert.service';
import { ProjectListService } from '../project-list.service';
import { ModalService } from "app/core/modal.service";
import { ChangeStatusModalComponent } from '../change-status-modal/change-status-modal.component';
import { StatusFilterComponent } from './status-filter/status-filter.component';
import { ClrDatagridStateInterface } from '@clr/angular/data/datagrid/interfaces/state.interface';

@Component({
  templateUrl: './project-list.component.html',
  providers: [ProjectListService]
})

export class ProjectListComponent implements OnInit {
  @HostBinding('class') className = 'content-container';
  projects: Paginator<Project>;
  searchStr: string;
  options: ListProjectOptions = new ListProjectOptions();
  isLoading: boolean;
  loading: boolean;
  selected: Project[] = [];
  currentPage: number = 1;
  opened: boolean = true;

  private currentState: ClrDatagridStateInterface;

  constructor(private projectService: ProjectService,
              private projectListService: ProjectListService,
              private alert: AlertService,
              private modal: ModalService) {
  }

  ngOnInit(): void {
    //this.loadProjects();

    this.refresh({});
  }

  showCreateProject() {
    const modalRef = this.modal.open(CreateProjectModal);
    modalRef.componentInstance.initNew();

    if (this.options.filters.client) {
      modalRef.componentInstance.setClient(this.options.filters.client);
    }
    modalRef.result.then(project => {
      this.refresh(this.currentState);
    });
  }

  rowsSelected() {
    return this.selected.length > 0;
  }

  refresh(state: ClrDatagridStateInterface) {
    this.currentState = state;
    this.loading = true;
    // We convert the filters from an array to a map,
    // because that's what our backend-calling service is expecting
    let filters: { [prop: string]: any[] } = {};
    if (state.filters) {
      for (let filter of state.filters) {
        if (filter instanceof StatusFilterComponent) {
          filters['status'] = filter.statuses;
        } else {
          let { property, value } = <{ property: string, value: string }>filter;
          filters[property] = [value];
        }
      }
    }

    console.log('refresh!', this.options.query);

    this.projectListService
      .sort(<{ by: string, reverse: boolean }>state.sort)
      .search(this.options.query)
      .clients(this.options.filters.client ? [this.options.filters.client] : [])
      .filter(filters)
      .fetch(this.currentPage, state.page ? state.page.size : null)
      .then((result: Paginator<Project>) => {
        this.projects = result;
        this.loading = false;
      });
  }

  deleteProjects() {
    if (!confirm(`Ta bort ${this.selected.length} projekt?`)) {
      return;
    }

    this.projectService.destroyMany(this.selected)
      .subscribe(ok => {
        this.alert.success(`${this.selected.length} projekt togs bort!`);
        this.loadProjects();
      }, err => {
        this.alert.error(err.statusText);
      });
  }

  showChangeStatus() {
    const ref = this.modal.open(ChangeStatusModalComponent);
    ref.componentInstance.projects = this.selected;
    ref.result.then(updated => {
      console.log(updated);
      if (updated) {
        this.loadProjects();
      }
    })
    /*const modalRef = this.modal.open(ChangeStatusModalComponent);
    modalRef.componentInstance.projects = this.selected;
    modalRef.result.then(updated => {
      if (updated) {
        this.loadProjects();
      }
    }).catch(() => {
    });*/
  }

  onToggled(toggle: boolean, project: Project) {
    let idx = this.selected.findIndex(p => p.id === project.id);

    if (idx > -1) {
      this.selected.splice(idx, 1);
    } else {
      this.selected.push(project);
    }
  }

  isChecked(project: Project): boolean {
    return this.selected.findIndex(p => p.id === project.id) > -1;
  }

  onPageChange(page: number) {
    console.log(page);
    this.options.page = page;
    this.loadProjects();
  }

  onFilterChange(filters: ProjectListFilter) {
    console.log('filters', filters);
    this.options.query = filters.searchString;
    this.options.page = 1;
    this.refresh(this.currentState);
  }

  setSorting(column: string) {
    this.options.sortBy = column;
    this.options.page = 1;
    this.refresh(this.currentState);
  }

  private loadProjects() {
    this.isLoading = true;
    this.projectService.get(this.options)
      .finally(() => {
        this.isLoading = false;
      })
      .subscribe(projects => {
        this.projects = projects;
      });
  }

  get isLoaded() {
    return this.projects;
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/list/project-list.component.ts